import { Component } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

/**
 * Catches render errors so the app shows a fallback instead of a white screen
 * (e.g. on reload at /dashboard/default).
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            p: 3,
            bgcolor: 'background.paper',
            textAlign: 'center'
          }}
        >
          <Typography variant="h5" gutterBottom>
            Something went wrong
          </Typography>
          <Typography color="text.secondary" sx={{ mb: 2, maxWidth: 400 }}>
            The page failed to load. Try refreshing or go back to login.
          </Typography>
          <Button variant="contained" onClick={this.handleRetry}>
            Reload page
          </Button>
          <Button sx={{ mt: 1 }} onClick={() => (window.location.href = '/login')}>
            Go to login
          </Button>
        </Box>
      );
    }
    return this.props.children;
  }
}
